<template>
    <div>
        <template
            v-if="mobile"
        >
            <summary-breakdown
                class="py-3 px-4"
                :object="benefits"
                :property="mobile_property"
                :small="small"
            ></summary-breakdown>

            <v-divider></v-divider>

            <summary-value
                class="py-3 px-4"
                :small="small"
                :object="benefits"
                property="lppMonthlyPremium"
            >
                <template v-slot:label>
                    {{ chosen }} {{ getLppLabel(client.lpp_type) }}
                </template>
            </summary-value>

        </template>
        <template
            v-else
        >
            <template
                v-for="(property, index) in properties_object"
            >
                <v-divider
                    v-if="index !== 0"
                    class="mx-4"
                ></v-divider>

                <summary-breakdown
                    class="py-3 px-4"
                    :object="benefits"
                    :property="property"
                    :key="'property-' + index"
                    :small="small"
                ></summary-breakdown>
            </template>

            <v-divider></v-divider>

            <template
                v-for="(property, index) in properties"
            >
                <summary-value
                    :key="index"
                    class="py-3 px-4"
                    :object="benefits"
                    :property="property"
                    :small="small"
                    :greyed="isGreyed(property)"
                    :inverted="isInverted(property)"
                ></summary-value>

                <v-divider></v-divider>
            </template>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-My-Cover',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            chosen() {
                return this.benefits_requested && this.client.lpp_type === this.benefits.recommendedLpp.value ? 'Recommended' : 'Selection';
            },
        },

        data() {
            return {
                properties_object: [],

                properties: [
                    'totalMyCover',
                    'totalMyCoverPremium'
                ],

                mobile_property: {
                    'label': 'Total MyCover™',
                    'values': [
                        'totalMyCover',
                        'totalMyCoverPremium'
                    ]
                },
            }
        },

        mounted() {
            this.setPropertyObjects();
        },

        methods: {
            isGreyed(property) {
                return property === 'totalMyCover';
            },
            isInverted(property) {
                return property === 'totalMyCoverPremium';
            },

            setPropertyObjects() {
                this.properties_object = [
                    {
                        'label': 'Base Cover & Premium',
                        'values': [
                            'baseCover',
                            'monthlyPremium'
                        ]
                    },
                    {
                        'label': 'BeneFactor™ & Premium',
                        'values': [
                            'beneFactorAmount',
                            'beneFactorPremium'
                        ]
                    }
                ];

                if (this.benefits_requested && typeof this.benefits.cashBackInTheFirstFiveYears !== 'undefined' && typeof this.benefits.cashBackInTheFirstFiveYears.value !== 'undefined' && this.benefits.cashBackInTheFirstFiveYears.value !== 0) {
                    this.properties_object.push(
                        {
                            'label': '5-year Cash Back',
                            'values': [
                                'cashBackInTheFirstFiveYears',
                            ]
                        }
                    );
                }

                this.properties_object.push(
                    {
                        'label': 'MyAbility™ & Premium',
                        'values': [
                            'myAbilityBenefit',
                            'myAbilityPremium',
                        ]
                    }
                );

            }
        }
    }
</script>
